import clsx from "clsx";
import { useTranslation } from "react-i18next";
import Select, { type GroupBase, type Props } from "react-select";

interface PropsInterface<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> extends Props<Option, IsMulti, Group> {
  // the right solution would be to use forwardRef, but it can't take generics; so we accopt a ref prop instead
  mRef?: React.Ref<any>;
}

export default function TTSelect<
  Option = unknown,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ mRef, className, ...props }: PropsInterface<Option, IsMulti, Group>) {
  const { t } = useTranslation(["translation"]);

  return (
    <Select
      ref={mRef}
      className={clsx("TT-react-select", className)}
      classNamePrefix="TT-react-select"
      placeholder={t("translation:global.choose…")}
      noOptionsMessage={() => t("translation:global.no_options")}
      {...props}
    />
  );
}
